import React from "react";

import close from "./assets/cross.svg";
import succ from "./assets/succ.svg";

interface RegisterConfirmedProps {
    setRegisterConfirmed: (show: boolean) => void;
}

const RegisterConfirmed: React.FC<RegisterConfirmedProps> = ({ setRegisterConfirmed }) => {
    return (
        <>
            <div className="w-full md:w-[120%] h-full bg-[#1212128d] z-[999] fixed top-0 left-0 md:-left-[20%] p-6 flex justify-center items-center">
                <div className="md:ml-[20%] bg-[#FFFFFF] p-6 rounded-[15px] w-full md:w-[600px]">
                    <div className="w-full h-full bg-[#fff] overflow-y-auto flex flex-col items-center text-center">
                        <span className=" w-full flex items-center justify-between">

                            <img
                                onClick={() => setRegisterConfirmed(false)}
                                src={close}
                                className=" w-4 cursor-pointer"
                                alt="Close"
                            />
                        </span>

                        <img src={succ} className=" w-[100px] h-[100px]" alt="Success" />
                        <h2 className=" font-Manrope font-semibold text-xl text-black mt-3">
                            Registration Confirmed for Match.
                        </h2>
                        <p className=" mt-2 font-Manrope font-normal text-base text-black">
                            You&apos;re successfully registered for this match.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RegisterConfirmed;
